<template>
  <div>
    <v-card elevation="12">
      <v-tabs color="primary" v-model="tab" icons-and-text grow>
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          Delivery
          <v-icon>local_shipping</v-icon>
        </v-tab>
        <v-tab>
          PostCode Request
          <v-icon>add_location</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-title>Do we deliver to you?</v-card-title>
            <PostcodeRequest
              :isRequestPostcode="notRequest"
              :descriptionText="descText1"
            /> 
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title>Request your PostCode to be added</v-card-title>
            <PostcodeRequest
              :isRequestPostcode="request"
              :descriptionText="descText2"
            >
            </PostcodeRequest>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import PostcodeRequest from "@/components/auth/PostcodeRequestForm.vue";
import checkEmail from "@/util/validation/email.js";
import { mapActions } from "vuex";

export default {
  name: "PostcodeDeliveryRequest",
  components: { PostcodeRequest },
  data: () => {
    return {
      tab: null,
      descText1:
        "Please enter your postcode below to check if we deliver to your address.",
      descText2:
        "We’re continually expanding, enter your postcode in the request box to add your postcode into our delivery round - We will be in touch if your postcode becomes successful.",
      notRequest: false,
      request: true,
      yourDetailsText:
        "Please provide us your details so that we can let you know once your postcode is added to our delivery area",
    };
  },
};
</script>